import { createRoute } from './utils'

const adminRoutes = {
	dashboard: createRoute('/admin', {
		id: 'dashboard',
		protect: true,
	}),

	leads: createRoute('/admin/leads', {
		id: 'leads',
		protect: true,
	}),

	users: {
		list: createRoute('/admin/users', {
			id: 'users',
			protect: true,
		}),
		new: createRoute('/admin/users/new', {
			id: 'new-user',
			protect: true,
		}),
		edit: createRoute('/admin/users/:id/edit', {
			id: 'edit-user',
			protect: true,
		}),
	},

	banner: createRoute('/admin/banner', {
		id: 'banner',
		protect: true,
	}),

	downloads: {
		list: createRoute('/admin/downloads', {
			id: 'downloads',
			protect: true,
		}),
		new: createRoute('/admin/downloads/new', {
			id: 'new-download',
			protect: true,
		}),
		edit: createRoute('/admin/downloads/:id/edit', {
			id: 'edit-download',
			protect: true,
		}),
	},

	warranties: {
		list: createRoute('/admin/warranties', {
			id: 'warranties',
			protect: true,
		}),
		downloadFile: createRoute('/admin/warranties/download-files/:code', {
			id: 'download-warranty-file',
			protect: true,
		}),
	},

	import: {
		manage: createRoute('/admin/resources/import', {
			id: 'import',
			protect: true,
		}),
		irisProducts: createRoute(
			'/admin/resources/import-iris-sapienstone-products',
			{
				id: 'import-iris-sapienstone-products',
				protect: true,
			},
		),
		initialize: createRoute('/admin/resources/initialize', {
			id: 'initialize',
			protect: true,
		}),
	},

	contactRequests: {
		list: createRoute('/admin/contact-requests', {
			id: 'contact-requests',
			protect: true,
		}),

		export: createRoute('/admin/contact-requests/export/:start/:end', {
			id: 'export-contact-requests',
			protect: true,
		}),
	},

	samplesRequests: {
		list: createRoute('/admin/samples-requests', {
			id: 'samples-requests',
			protect: true,
		}),
	},

	newsletters: {
		list: createRoute('/admin/newsletters', {
			id: 'newsletters',
			protect: true,
		}),
	},

	stores: {
		list: createRoute('/admin/stores', {
			id: 'stores',
			protect: true,
		}),

		new: createRoute('/admin/stores/new', {
			id: 'new-store',
			protect: true,
		}),

		edit: createRoute('/admin/stores/:id/edit', {
			id: 'edit-store',
			protect: true,
		}),
	},

	materials: {
		list: createRoute('/admin/materials', {
			id: 'materials',
			protect: true,
		}),
		new: createRoute('/admin/materials/new', {
			id: 'new-product',
			protect: true,
		}),
		view: createRoute('/admin/materials/:slug/general', {
			id: 'view-product',
			protect: true,
		}),
		uploadImages: createRoute('/admin/materials/:slug/upload-images', {
			id: 'upload-product-images',
			protect: true,
		}),

		edit: {
			general: createRoute('/admin/materials/:slug/general', {
				id: 'edit-product-general',
				protect: true,
			}),
			designs: createRoute('/admin/materials/:slug/designs', {
				id: 'edit-product-designs',
				protect: true,
			}),
			ambients: createRoute('/admin/materials/:slug/ambients', {
				id: 'edit-product-ambient',
				protect: true,
			}),
			characteristics: createRoute('/admin/materials/:slug/characteristics', {
				id: 'edit-product-characteristics',
				protect: true,
			}),
			variants: {
				list: createRoute('/admin/materials/:slug/variants', {
					id: 'edit-product-variants',
					protect: true,
				}),
				new: createRoute('/admin/materials/:slug/variants/new', {
					id: 'new-product-variant',
					protect: true,
				}),
				edit: createRoute('/admin/materials/:slug/variants/:id', {
					id: 'edit-product-variant',
					protect: true,
				}),
			},
			uploadImages: createRoute('/admin/materials/:slug/upload-images', {
				id: 'upload-product-images',
				protect: true,
			}),
		},

		sizes: {
			list: createRoute('/admin/materials/sizes', {
				id: 'product-sizes',
				protect: true,
			}),
			new: createRoute('/admin/materials/sizes/new', {
				id: 'new-product-size',
				protect: true,
			}),
		},

		widths: {
			list: createRoute('/admin/materials/widths', {
				id: 'product-widths',
				protect: true,
			}),
			new: createRoute('/admin/materials/widths/new', {
				id: 'new-product-width',
				protect: true,
			}),
		},

		typologies: {
			list: createRoute('/admin/materials/typologies', {
				id: 'product-typologies',
				protect: true,
			}),
			new: createRoute('/admin/materials/typologies/new', {
				id: 'new-product-typology',
				protect: true,
			}),
			edit: createRoute('/admin/materials/typologies/:id/edit', {
				id: 'edit-product-typology',
				protect: true,
			}),
		},

		colors: {
			list: createRoute('/admin/materials/colors', {
				id: 'product-colors',
				protect: true,
			}),
			new: createRoute('/admin/materials/colors/new', {
				id: 'new-product-color',
				protect: true,
			}),
			edit: createRoute('/admin/materials/colors/:id/edit', {
				id: 'edit-product-color',
				protect: true,
			}),
		},

		finishes: {
			list: createRoute('/admin/materials/finishes', {
				id: 'product-finishes',
				protect: true,
			}),
			new: createRoute('/admin/materials/finishes/new', {
				id: 'new-product-finish',
				protect: true,
			}),
			edit: createRoute('/admin/materials/finishes/:id/edit', {
				id: 'edit-product-finish',
				protect: true,
			}),
		},
	},

	blog: {
		posts: {
			list: createRoute('/admin/magazine/posts', {
				id: 'blog-posts',
				protect: true,
			}),
			new: createRoute('/admin/magazine/posts/new', {
				id: 'new-blog-post',
				protect: true,
			}),
			edit: createRoute('/admin/magazine/posts/:id/edit/:locale', {
				id: 'edit-blog-post',
				protect: true,
			}),
			translate: createRoute('/admin/magazine/posts/:id/translate/:locale', {
				id: 'add-blog-post-translation',
				protect: true,
			}),
			api: {
				uploadImage: createRoute('/admin/magazine/posts/upload-image', {
					id: 'upload-blog-post-image',
					protect: true,
				}),
			},
		},

		categories: {
			list: createRoute('/admin/magazine/categories', {
				id: 'blog-categories',
				protect: true,
			}),
			new: createRoute('/admin/magazine/categories/new', {
				id: 'new-blog-category',
				protect: true,
			}),
			edit: createRoute('/admin/magazine/categories/:id/edit', {
				id: 'edit-blog-category',
				protect: true,
			}),
		},
	},

	redirects: createRoute('/admin/redirects', {
		id: 'redirects',
		protect: true,
	}),
	newRedirect: createRoute('/admin/redirects/new', {
		id: 'newRedirect',
		protect: true,
	}),

	observability: {
		index: createRoute('/admin/observability', {
			id: 'observability',
			protect: true,
		}),
		errorAlerts: createRoute('/admin/observability/error-alerts', {
			id: 'observability-error-alerts',
			protect: true,
		}),
		errorAlertDetail: createRoute('/admin/observability/error-alerts/:id', {
			id: 'observability-error-alert-detail',
			protect: true,
		}),
		metrics: createRoute('/admin/observability/metrics', {
			id: 'observability-metrics',
			protect: true,
		}),
		logs: createRoute('/admin/observability/logs', {
			id: 'observability-logs',
			protect: true,
		}),
		cleanup: createRoute('/admin/observability/cleanup', {
			id: 'observability-cleanup',
			protect: true,
		}),
	},
}

export default adminRoutes
